/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const DangerAlertIcon = ({ width = 16, height = 16, ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z'
      fill='#A81A0A'
    />
    <path
      d='M6.97872 12.3121C6.97872 11.7589 7.40426 11.2908 8 11.2908C8.55319 11.2908 9.02128 11.7589 8.97872 12.3121C8.97872 12.9078 8.55319 13.3333 8 13.3333C7.44681 13.3333 6.97872 12.9078 6.97872 12.3121Z'
      fill='#F7F9FA'
    />
    <path
      d='M8.6667 9.47518C8.6667 9.85816 8.36883 10.156 8.0284 10.156C7.64543 10.156 7.34755 9.85816 7.34755 9.47518V3.34752C7.34755 3.00709 7.68798 2.66667 8.0284 2.66667C8.32628 2.66667 8.6667 3.00709 8.6667 3.34752V9.47518Z'
      fill='#F7F9FA'
    />
  </svg>
);

export default DangerAlertIcon;
